import http from "@/settings/apiSettings"
import ODataStore from "devextreme/data/odata/store";

class PreturiFurinizoriDataService {
    getPartners(): Promise<any> {
        
      return http.clientComercial.get("PAR_ParteneriHelpers/GetFurnizoriFeeduriPret");
    } 
    
}

export default new PreturiFurinizoriDataService();